<template>
    <div>
        <limitless-page-header :title="'Varumärken'"></limitless-page-header>

        <div class="content" v-if="busy_loading">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div v-else class="content">
            <rednax-datatable
                :data="Object.values(rows || [])"
                :columns="table_columns"
                sort-by="ProdName"
                sort-order="asc"
                :rowClass="rowClass"
            >
                <template #cell_prod_net_price="{ row }">
                    <input type="number" :value="(rows[row.prod_id] && rows[row.prod_id].prod_net_price ? rows[row.prod_id].prod_net_price : '')" @input="setValue(row.prod_id, 'prod_net_price', $event)" step="1">
                </template>
                <template #cell_recommended_retail_price="{ row }">
                    <input type="number" :value="(rows[row.prod_id] && rows[row.prod_id].recommended_retail_price ? rows[row.prod_id].recommended_retail_price : '')" @input="setValue(row.prod_id, 'recommended_retail_price', $event)" step="1">
                </template>
                <template #footer>
                    <div style="text-align: right;">
                        <limitless-button ref="btnsave" :busy="busy_saving" icon="icon-floppy-disk" @click.prevent="savePrices">SPARA</limitless-button>
                    </div>
                </template>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';

export default {
    name: 'ProductPriceUpdateNPH',
    components: {
        LimitlessButton,
        LimitlessPageHeader,
        RednaxDatatable,
    },
    data: () => ({
        rows: null,
        busy_loading: true,
        busy_saving: false,
        table_columns: [
            {
                header: '#',
                data: 'prod_id',
                sortable: true,
            },
            {
                header: 'Namn',
                data: 'prod_name',
                sortable: true,
            },
            {
                header: 'Lev. Artnr.',
                data: 'prod_supplier_sku',
                sortable: true,
            },
            {
                header: 'Inköpspris',
                data: 'current_prod_net_price',
                sortable: true,
            },
            {
                header: 'Inköpspris NPH',
                data: 'nph_prod_net_price',
                sortable: true,
            },
            {
                header: 'Nytt Inköpspris',
                data: 'prod_net_price',
                sortable: false,
            },
            {
                header: 'Rek. förs.pris',
                data: 'current_recommended_retail_price',
                sortable: true,
            },
            {
                header: 'Förs.pris NPH',
                data: 'nph_recommended_retail_price',
                sortable: true,
            },
            {
                header: 'Nytt Förs.pris',
                data: 'recommended_retail_price',
                sortable: false,
            },
        ],
    }),
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            apiClient.get('/vue/products/multiupdate/price-nph/get').then((res) => {
                this.rows = res.data.products;
                this.not_found = res.data.not_found;
            }).finally(() => {
                this.busy_loading = false;
            });
        },
        async savePrices() {
            this.busy_saving = true;
            await apiClient.post('/vue/products/multiupdate', { products: this.rows })
                .then(() => {
                    this.$refs.btnsave.triggerSaved();
                    this.getData();
                }).catch(() => {
                    this.$refs.btnsave.triggerFailed();
                }).finally(() => {
                    this.busy_saving = false;
                });
        },
        setValue(prodId, attribute, event) {
            const price = (event.target.value ? parseInt(event.target.value, 10) : '');
            if (!this.rows[prodId]) {
                this.$set(this.rows, prodId, {});
            }
            this.rows[prodId][attribute] = price;
        },
        rowClass(row) {
            if (
                (row.current_prod_net_price > 0 && row.prod_net_price > 0 && row.nph_prod_net_price < row.current_prod_net_price / 1.1)
                || (row.current_recommended_retail_price > 0 && row.recommended_retail_price > 0 && row.nph_recommended_retail_price < row.current_recommended_retail_price / 1.1)
            ) {
                return 'bg-warning';
            }
            if (row.prod_net_price > 0 || row.recommended_retail_price > 0) {
                return 'bg-yellow';
            }
            return '';
        },
    },
};

</script>
